var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4 15.75c-1.12 0-2.14-.58-2.71-1.55-.57-.97-.59-2.13-.05-3.12l4.51-8.21a3.105 3.105 0 0 1 2.76-1.63c1.17 0 2.2.61 2.76 1.63l4.52 8.21c.54.98.52 2.15-.05 3.12-.57.97-1.59 1.55-2.71 1.55H4.4zM7.47 3.6l-4.51 8.21c-.28.52-.27 1.12.02 1.63.3.51.83.81 1.42.81h9.03c.59 0 1.12-.3 1.42-.81.3-.51.31-1.11.02-1.63L10.35 3.6c-.29-.53-.83-.85-1.44-.85s-1.15.32-1.44.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5c0-.18.01-.36.02-.54.02-.4.35-.71.75-.71h4.41c.59 0 1.12-.3 1.42-.81.3-.51.31-1.11.02-1.63l-1.28-2.33a.742.742 0 0 1-.02-.68c.1-.22.3-.37.53-.42.45-.09.92-.13 1.4-.13 4 0 7.25 3.25 7.25 7.25s-3.25 7.25-7.25 7.25-7.25-3.25-7.25-7.25zm7.25 5.75c3.17 0 5.75-2.58 5.75-5.75s-2.58-5.75-5.75-5.75h-.05l.74 1.34c.54.98.52 2.15-.05 3.12a3.11 3.11 0 0 1-2.71 1.55H9.76v-.01c.13 3.06 2.66 5.5 5.74 5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineShapes);
export default __webpack_public_path__ + "static/media/vuesax-outline-shapes.da18a901a693902ad8664af98bf8649e.svg";
export { ForwardRef as ReactComponent };